import { render } from "./ExitScanAndGo.vue?vue&type=template&id=40717d70&scoped=true"
import script from "./ExitScanAndGo.vue?vue&type=script&lang=js"
export * from "./ExitScanAndGo.vue?vue&type=script&lang=js"

import "./ExitScanAndGo.vue?vue&type=style&index=0&id=40717d70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40717d70"]])

export default __exports__